<script>
    import { t } from '../i18n.js'
    import ViewCardContainer from '../components/ViewCardContainer.svelte'
    import { onMount } from 'svelte'
    import {locale} from '../store/stores'

    let nonAccessibles
    $: $locale, setNonAccessibles()
    
    function setNonAccessibles() {
        nonAccessibles =  $t('accessibility.non-accessible-content').split('.')
    }

    onMount(() => {
		window.scrollTo(0,0)
	})
</script>

<ViewCardContainer pageTitle={$t('accessibility.page-title')}>
    <p class="mb-4">{$t('accessibility.description')}</p>
    <h2 class="mt-8 mb-2">{$t('accessibility.state-subtitle')}</h2>    
    <p class="mb-4">{$t('accessibility.state-description')} </p>
    <h2 class="mt-8 mb-2">{$t('accessibility.non-accessible-subtitle')}</h2>    
    <p class="mb-4">{$t('accessibility.non-accessible-description')} </p>
    <ul style="margin: 0 0 0 25px">
        {#each nonAccessibles as nonAccessible}
            <li style="list-style-type: disc;">{nonAccessible}</li>
        {/each}
    </ul>
</ViewCardContainer>